import React from 'react';
import { DashboardLayout } from '@vette/ui-components';
import { firebase } from '@vette/frontend-utils';
import { vetter } from '@vette/pages';

const Payouts = () => {
  return (
    <>
      <firebase.FirebaseClaims
        required={{ id: true }}
        fallback={<DashboardLayout loading />}
      >
        {({ id }) => <vetter.PayoutsPage userId={id} />}
      </firebase.FirebaseClaims>
    </>
  );
};

export default Payouts;
